module.exports = __webpack_public_path__ + "img/payment-failed-th.7b41b86.png";